import { render, staticRenderFns } from "./OtifReport.vue?vue&type=template&id=73be2a9c&"
import script from "./OtifReport.vue?vue&type=script&lang=js&"
export * from "./OtifReport.vue?vue&type=script&lang=js&"
import style0 from "./OtifReport.vue?vue&type=style&index=0&id=73be2a9c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports